import { LogoBadgeSize } from './types';

/* 
  Sizing differs between base and subscription logo badges.
  This is because the subscription logos contain vertical padding in their SVGs, whereas the base logo badges do not.
  The actual content size of the subscription logos is equivalent to the baseBadgeSizeToPx values.
  
  This is described more in the Figma file:
  https://www.figma.com/design/q8QhW9wZjYVZRnYK1LQ88O/Alltrails-Subscription-Badges?node-id=0-1&t=0123UjK8JZKXJZ0u-0
  And Slack thread: 
  https://alltrails.slack.com/archives/C08HTFD64S1/p1744304279004819
*/

// Peak & Plus logo badge sizes
export const subscriptionBadgeSizeToPx: Record<LogoBadgeSize, number> = {
  sm: 18,
  md: 24,
  lg: 30,
  xl: 36
};

// Base logo badge sizes
export const baseBadgeSizeToPx: Record<LogoBadgeSize, number> = {
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24
};
